<div class="container mes-creations">
  <app-header-mobile *ngIf="currentUrl" class="d-md-none d-lg-block"></app-header-mobile>
  <div class="block-heading">
    <h2 *ngIf="currentUrl">
      {{ 'MENU_CREATIONS' | translate }} <span class="small">({{ totalAudioStories }})</span>
    </h2>
    <h2 *ngIf="!currentUrl" (click)="goToMyAudioContents()" class="workspace-header">
      {{ 'WORKSPACE_CREATIONS' | translate }}
    </h2>
  </div>

  <div style="width: 100%; display: flex; flex-wrap: wrap; justify-content: center">
    <ng-container *ngFor="let audioStory of audioContents; let i = index">
      <div *ngIf="!isDrawerToggled[audioStory.id]">
        <div class="card card-container">
          <img
            *ngIf="hasImage(audioStory) && hasBeenGenerated(audioStory)"
            class="card-img"
            src="{{ getFirstImageFromItems(audioStory) }}"
            alt=""
            height="320px"
            width="320px"
          />
          <img
            *ngIf="!hasImage(audioStory) && hasBeenGenerated(audioStory)"
            class="card-img"
            src="assets/images/audiostory/audiostory-audio.png"
            alt=""
            height="320px"
            width="320px"
          />
          <img
            *ngIf="hasImage(audioStory) && !hasBeenGenerated(audioStory)"
            alt=""
            src="{{ getFirstImageFromItems(audioStory) }}"
            class="card-img"
            height="320px"
            width="320px"
          />

          <img
            *ngIf="!hasBeenGenerated(audioStory) && contentLang === 'en' && !hasImage(audioStory)"
            class="card-img"
            src="assets/images/audiostory/audiostory-image-en.png"
            alt=""
            height="320px"
            width="320px"
          />
          <img
            *ngIf="!hasBeenGenerated(audioStory) && contentLang === 'fr' && !hasImage(audioStory)"
            class="card-img"
            src="assets/images/audiostory/audiostory-image-fr.png"
            alt=""
          />
          <div
            (click)="toggleDrawer(audioStory.id, $event)"
            class="card-img-overlay d-flex flex-column text-white p-4"
            [ngClass]="{ 'card-video': hasBeenGenerated(audioStory) && hasImage(audioStory) }"
          >
            <div class="d-flex">
              <h4
                class="d-flex card-title"
                click-edit
                (onChange)="updateAudioStoryName($event, audioStory)"
                id="click-edit"
              >
                {{ audioStory.name }}
              </h4>
              <span id="dropdownSpan" (click)="toggleActionDropdown(audioStory.id)" class="ms-auto actions-bt"
                ><i id="dropdownIcon" class="fa fa-ellipsis-v"></i
              ></span>
            </div>
            <h6 class="card-subtitle mb-2">{{ audioStory.updatedAt | date: 'd MMM y, H:mm' }}</h6>
            <div *ngIf="isActionDropdownToggled[audioStory.id]" class="actions-box-list shadow">
              <ul class="nav flex-column">
                <li
                  (click)="editAudioContent(audioStory)"
                  class="nav-item d-flex align-items-center justify-content-start"
                >
                  <a class="nav-link">
                    <span class="feature-box-link">{{ 'EDIT' | translate }}</span></a
                  >
                </li>
                <li
                  id="delete-list"
                  (click)="deleteAudioContent(audioStory)"
                  class="nav-item d-flex align-items-center justify-content-start"
                >
                  <a id="delete-link" class="nav-link">
                    <span id="delete-span" class="feature-box-link">{{ 'DELETE' | translate }}</span></a
                  >
                </li>
                <li
                  (click)="cloneAudioStory(audioStory)"
                  id="clone-list"
                  class="nav-item d-flex align-items-center justify-content-start"
                >
                  <a class="nav-link" id="clone-link">
                    <span id="clone-span" class="feature-box-link">{{ 'CLONE' | translate }}</span></a
                  >
                </li>
              </ul>
            </div>
            <div *ngIf="hasBeenGenerated(audioStory)" class="bt-overlay">
              <button class="bt-bottom">
                <i class="fa fa-angle-up dropdown-icon" aria-hidden="true"></i>
              </button>
            </div>
          </div>
        </div>
      </div>

      <div *ngIf="isDrawerToggled[audioStory.id]">
        <div class="card over-card">
          <img
            *ngIf="hasImage(audioStory) && hasBeenGenerated(audioStory)"
            class="card-img"
            src="{{ getFirstImageFromItems(audioStory) }}"
            alt=""
            height="320px"
            width="320px"
          />
          <img
            *ngIf="!hasImage(audioStory) && hasBeenGenerated(audioStory)"
            class="card-img"
            src="assets/images/audiostory/audiostory-audio.png"
            alt=""
            height="320px"
            width="320px"
          />
          <img
            *ngIf="!hasBeenGenerated(audioStory)"
            class="card-img"
            src="assets/images/audiostory/audiostory-image-en.png"
            alt=""
            height="320px"
            width="320px"
          />
          <div class="card-video-top bg-white d-flex-column">
            <div class="row justify-content-center">
              <button (click)="toggleDrawer(audioStory.id, $event)" class="bt-top">
                <i class="fa fa-angle-down dropdown-icon" aria-hidden="true"></i>
              </button>
            </div>

            <div *ngIf="!hasBeenGenerated(audioStory)">
              <div class="col-sm-12 d-flex align-items-center justify-content-center pb-2 border-bottom">
                <div class="d-flex align-items-center justify-content-center">
                  <button
                    (click)="editAudioContent(audioStory); trackEvent('creations-edit-unfinished-creation')"
                    class="btn btn-primary generate-button"
                  >
                    {{ 'GENERATE_A_FORMAT' | translate }}
                  </button>
                </div>
              </div>
            </div>

            <div *ngIf="hasAudioAssets(audioStory)" class="row">
              <div class="col-12 d-flex align-items-center pb-2 border-bottom">
                <div class="d-flex align-items-center p-1 flex-grow-1">
                  <svg id="Calque_1" data-name="Calque 1" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
                    <g id="Groupe_668" data-name="Groupe 668">
                      <path d="M12,19.5a.85.85,0,0,1-.85-.85V5.35a.85.85,0,0,1,1.7,0v13.3A.85.85,0,0,1,12,19.5Z" />
                      <path d="M5.2,15.92a.85.85,0,0,1-.85-.85V8.93a.85.85,0,0,1,1.7,0v6.14A.85.85,0,0,1,5.2,15.92Z" />
                      <path d="M8.6,17.27a.86.86,0,0,1-.85-.85V7.58a.85.85,0,0,1,1.7,0v8.84A.86.86,0,0,1,8.6,17.27Z" />
                      <path
                        d="M15.4,17.27a.86.86,0,0,1-.85-.85V7.58a.85.85,0,0,1,1.7,0v8.84A.86.86,0,0,1,15.4,17.27Z"
                      />
                      <path
                        d="M18.8,15.92a.85.85,0,0,1-.85-.85V8.93a.85.85,0,0,1,1.7,0v6.14A.85.85,0,0,1,18.8,15.92Z"
                      />
                    </g>
                  </svg>
                  <h5>Audio</h5>
                </div>
                <ng-container *ngIf="_success | async as success">
                  <div #selfClosingAlert *ngIf="success.format === 'audio'" type="success" class="embed-alert">
                    {{ 'COPIED' | translate }}
                  </div>
                </ng-container>
                <div class="p-1">
                  <span (click)="copyToClipboard(audioStory, audioStory.assets.audioStream, 'audio')">
                    <svg id="Calque_1" data-name="Calque 1" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
                      <defs>
                        <style>
                          .cls-1 {
                            fill: #fff;
                          }
                        </style>
                      </defs>
                      <path
                        class="cls-1"
                        d="M8.41,16a.85.85,0,0,1-.56-.21L4.14,12.64a.83.83,0,0,1-.3-.64.87.87,0,0,1,.3-.65L7.85,8.17A.85.85,0,1,1,9,9.46L6,12l3,2.54a.85.85,0,0,1,.09,1.2A.83.83,0,0,1,8.41,16Z"
                      />
                      <path
                        class="cls-1"
                        d="M15.59,16a.83.83,0,0,1-.64-.3.85.85,0,0,1,.09-1.2L18,12,15,9.46a.85.85,0,0,1,1.11-1.29l3.71,3.18a.87.87,0,0,1,.3.65.83.83,0,0,1-.3.64l-3.71,3.19A.85.85,0,0,1,15.59,16Z"
                      />
                      <path
                        class="cls-1"
                        d="M10.93,18.42h-.16a.87.87,0,0,1-.68-1L12.24,6.27a.86.86,0,0,1,1-.68.87.87,0,0,1,.68,1L11.76,17.73A.84.84,0,0,1,10.93,18.42Z"
                      /></svg
                  ></span>
                </div>
                <div class="p-1">
                  <span (click)="setAudioPlayerSource(audioStory.assets.audioStream, 'audio')">
                    <svg data-name="Calque 1" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
                      <path
                        d="M7 12V6.78a1.34 1.34 0 012-1.15l8.52 5.12a1.46 1.46 0 010 2.5L9 18.37a1.34 1.34 0 01-2-1.15z"
                        fill="#fff"
                      ></path>
                    </svg>
                  </span>
                </div>
                <div class="p-1">
                  <span (click)="downloadSource(audioStory.assets.audioAttachment, 'audio')">
                    <svg id="Calque_1" data-name="Calque 1" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
                      <defs>
                        <style>
                          .cls-1 {
                            fill: #fff;
                          }
                        </style>
                      </defs>
                      <path
                        class="cls-1"
                        d="M11.41 17.08a.26.26 0 00.11.07.91.91 0 00.16.11.88.88 0 00.64 0 .91.91 0 00.16-.11.26.26 0 00.11-.07L16 13.81a.85.85 0 10-1.18-1.22l-1.94 1.88V5.35a.85.85 0 00-1.7 0v9.12l-1.97-1.88A.85.85 0 008 13.81z"
                      ></path>
                      <path
                        class="cls-1"
                        d="M18.5 16.57a.85.85 0 00-.85.85v1.64H6.35v-1.64a.85.85 0 00-1.7 0v2.49a.85.85 0 00.85.85h13a.85.85 0 00.85-.85v-2.49a.85.85 0 00-.85-.85z"
                      ></path>
                    </svg>
                  </span>
                </div>
              </div>
            </div>

            <div *ngIf="hasMobileVideoAssets(audioStory)" class="row">
              <div class="col-12 d-flex align-items-center py-2 border-bottom">
                <div class="col-auto d-flex align-items-center flex-grow-1 p-1">
                  <svg data-name="Calque 1" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
                    <rect x="5.92" y="1.79" width="12.15" height="20.42" rx="1.7" fill="#dad8df"></rect>
                    <path
                      d="M16.37 23H7.63a2.51 2.51 0 01-2.51-2.5v-17A2.51 2.51 0 017.63 1h8.74a2.51 2.51 0 012.51 2.5v17a2.51 2.51 0 01-2.51 2.5zM7.63 2.59a.91.91 0 00-.91.9v17a.91.91 0 00.91.9h8.74a.91.91 0 00.91-.9v-17a.91.91 0 00-.91-.9z"
                      fill="#160a36"
                    ></path>
                  </svg>
                  <h5>{{ 'PORTRAIT_VIDEO' | translate }}</h5>
                </div>
                <ng-container *ngIf="_success | async as success">
                  <div #selfClosingAlert *ngIf="success.format === 'mobile-video'" type="success" class="embed-alert">
                    {{ 'COPIED' | translate }}
                  </div>
                </ng-container>
                <div class="p-1">
                  <span (click)="copyToClipboard(audioStory, audioStory.assets.videoMobileStream, 'mobile-video')">
                    <svg id="Calque_1" data-name="Calque 1" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
                      <defs>
                        <style>
                          .cls-1 {
                            fill: #fff;
                          }
                        </style>
                      </defs>
                      <path
                        class="cls-1"
                        d="M8.41,16a.85.85,0,0,1-.56-.21L4.14,12.64a.83.83,0,0,1-.3-.64.87.87,0,0,1,.3-.65L7.85,8.17A.85.85,0,1,1,9,9.46L6,12l3,2.54a.85.85,0,0,1,.09,1.2A.83.83,0,0,1,8.41,16Z"
                      />
                      <path
                        class="cls-1"
                        d="M15.59,16a.83.83,0,0,1-.64-.3.85.85,0,0,1,.09-1.2L18,12,15,9.46a.85.85,0,0,1,1.11-1.29l3.71,3.18a.87.87,0,0,1,.3.65.83.83,0,0,1-.3.64l-3.71,3.19A.85.85,0,0,1,15.59,16Z"
                      />
                      <path
                        class="cls-1"
                        d="M10.93,18.42h-.16a.87.87,0,0,1-.68-1L12.24,6.27a.86.86,0,0,1,1-.68.87.87,0,0,1,.68,1L11.76,17.73A.84.84,0,0,1,10.93,18.42Z"
                      /></svg
                  ></span>
                </div>
                <div class="p-1">
                  <span (click)="openAudioStoryModal(audioStory.assets.videoMobileStream, 'mobile-video')">
                    <svg data-name="Calque 1" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
                      <path
                        d="M7 12V6.78a1.34 1.34 0 012-1.15l8.52 5.12a1.46 1.46 0 010 2.5L9 18.37a1.34 1.34 0 01-2-1.15z"
                        fill="#fff"
                      ></path>
                    </svg>
                  </span>
                </div>
                <div class="p-1">
                  <span (click)="downloadSource(audioStory.assets.videoMobileAttachment, 'mobile-video')">
                    <svg id="Calque_1" data-name="Calque 1" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
                      <defs>
                        <style>
                          .cls-1 {
                            fill: #fff;
                          }
                        </style>
                      </defs>
                      <path
                        class="cls-1"
                        d="M11.41 17.08a.26.26 0 00.11.07.91.91 0 00.16.11.88.88 0 00.64 0 .91.91 0 00.16-.11.26.26 0 00.11-.07L16 13.81a.85.85 0 10-1.18-1.22l-1.94 1.88V5.35a.85.85 0 00-1.7 0v9.12l-1.97-1.88A.85.85 0 008 13.81z"
                      ></path>
                      <path
                        class="cls-1"
                        d="M18.5 16.57a.85.85 0 00-.85.85v1.64H6.35v-1.64a.85.85 0 00-1.7 0v2.49a.85.85 0 00.85.85h13a.85.85 0 00.85-.85v-2.49a.85.85 0 00-.85-.85z"
                      ></path></svg
                  ></span>
                </div>
              </div>
            </div>

            <div *ngIf="hasSquareVideoAssets(audioStory)" class="row">
              <div class="col-12 d-flex align-items-center py-2">
                <div class="d-flex align-items-center p-1 flex-grow-1">
                  <svg data-name="Calque 1" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
                    <rect x="3.67" y="3.67" width="16.67" height="16.67" rx="1.8" fill="#dad8df"></rect>
                    <path
                      d="M18.53 21.13H5.47a2.59 2.59 0 01-2.6-2.6V5.47a2.59 2.59 0 012.6-2.6h13.06a2.59 2.59 0 012.6 2.6v13.06a2.59 2.59 0 01-2.6 2.6zM5.47 4.47a1 1 0 00-1 1v13.06a1 1 0 001 1h13.06a1 1 0 001-1V5.47a1 1 0 00-1-1z"
                      fill="#160a36"
                    ></path>
                  </svg>
                  <h5>{{ 'SQUARE_VIDEO' | translate }}</h5>
                </div>
                <ng-container *ngIf="_success | async as success">
                  <div #selfClosingAlert *ngIf="success.format === 'square-video'" type="success" class="embed-alert">
                    {{ 'COPIED' | translate }}
                  </div>
                </ng-container>
                <div class="p-1">
                  <span (click)="copyToClipboard(audioStory, audioStory.assets.videoStream, 'square-video')">
                    <svg id="Calque_1" data-name="Calque 1" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
                      <defs>
                        <style>
                          .cls-1 {
                            fill: #fff;
                          }
                        </style>
                      </defs>
                      <path
                        class="cls-1"
                        d="M8.41,16a.85.85,0,0,1-.56-.21L4.14,12.64a.83.83,0,0,1-.3-.64.87.87,0,0,1,.3-.65L7.85,8.17A.85.85,0,1,1,9,9.46L6,12l3,2.54a.85.85,0,0,1,.09,1.2A.83.83,0,0,1,8.41,16Z"
                      />
                      <path
                        class="cls-1"
                        d="M15.59,16a.83.83,0,0,1-.64-.3.85.85,0,0,1,.09-1.2L18,12,15,9.46a.85.85,0,0,1,1.11-1.29l3.71,3.18a.87.87,0,0,1,.3.65.83.83,0,0,1-.3.64l-3.71,3.19A.85.85,0,0,1,15.59,16Z"
                      />
                      <path
                        class="cls-1"
                        d="M10.93,18.42h-.16a.87.87,0,0,1-.68-1L12.24,6.27a.86.86,0,0,1,1-.68.87.87,0,0,1,.68,1L11.76,17.73A.84.84,0,0,1,10.93,18.42Z"
                      /></svg
                  ></span>
                </div>
                <div class="p-1">
                  <span (click)="openAudioStoryModal(audioStory.assets.videoStream, 'square-video')">
                    <svg data-name="Calque 1" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
                      <path
                        d="M7 12V6.78a1.34 1.34 0 012-1.15l8.52 5.12a1.46 1.46 0 010 2.5L9 18.37a1.34 1.34 0 01-2-1.15z"
                        fill="#fff"
                      ></path>
                    </svg>
                  </span>
                </div>
                <div class="p-1">
                  <span (click)="downloadSource(audioStory.assets.videoAttachment, 'square-video')">
                    <svg id="Calque_1" data-name="Calque 1" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
                      <defs>
                        <style>
                          .cls-1 {
                            fill: #fff;
                          }
                        </style>
                      </defs>
                      <path
                        class="cls-1"
                        d="M11.41 17.08a.26.26 0 00.11.07.91.91 0 00.16.11.88.88 0 00.64 0 .91.91 0 00.16-.11.26.26 0 00.11-.07L16 13.81a.85.85 0 10-1.18-1.22l-1.94 1.88V5.35a.85.85 0 00-1.7 0v9.12l-1.97-1.88A.85.85 0 008 13.81z"
                      ></path>
                      <path
                        class="cls-1"
                        d="M18.5 16.57a.85.85 0 00-.85.85v1.64H6.35v-1.64a.85.85 0 00-1.7 0v2.49a.85.85 0 00.85.85h13a.85.85 0 00.85-.85v-2.49a.85.85 0 00-.85-.85z"
                      ></path>
                    </svg>
                  </span>
                </div>
              </div>
            </div>

            <div *ngIf="hasLandscapeVideoAssets(audioStory)" class="row">
              <div class="col-12 d-flex align-items-center py-2 border-bottom">
                <div class="col-auto d-flex align-items-center flex-grow-1 p-1">
                  <svg
                    style="transform: rotate(90deg)"
                    data-name="Calque 1"
                    xmlns="http://www.w3.org/2000/svg"
                    viewBox="0 0 24 24"
                  >
                    <rect x="5.92" y="1.79" width="12.15" height="20.42" rx="1.7" fill="#dad8df"></rect>
                    <path
                      d="M16.37 23H7.63a2.51 2.51 0 01-2.51-2.5v-17A2.51 2.51 0 017.63 1h8.74a2.51 2.51 0 012.51 2.5v17a2.51 2.51 0 01-2.51 2.5zM7.63 2.59a.91.91 0 00-.91.9v17a.91.91 0 00.91.9h8.74a.91.91 0 00.91-.9v-17a.91.91 0 00-.91-.9z"
                      fill="#160a36"
                    ></path>
                  </svg>
                  <h5>{{ 'LANDSCAPE_VIDEO' | translate }}</h5>
                </div>
                <ng-container *ngIf="_success | async as success">
                  <div
                    #selfClosingAlert
                    *ngIf="success.format === 'landscape-video'"
                    type="success"
                    class="embed-alert"
                  >
                    {{ 'COPIED' | translate }}
                  </div>
                </ng-container>
                <div class="p-1">
                  <span
                    (click)="copyToClipboard(audioStory, audioStory.assets.videoLandscapeStream, 'landscape-video')"
                  >
                    <svg id="Calque_1" data-name="Calque 1" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
                      <defs>
                        <style>
                          .cls-1 {
                            fill: #fff;
                          }
                        </style>
                      </defs>
                      <path
                        class="cls-1"
                        d="M8.41,16a.85.85,0,0,1-.56-.21L4.14,12.64a.83.83,0,0,1-.3-.64.87.87,0,0,1,.3-.65L7.85,8.17A.85.85,0,1,1,9,9.46L6,12l3,2.54a.85.85,0,0,1,.09,1.2A.83.83,0,0,1,8.41,16Z"
                      />
                      <path
                        class="cls-1"
                        d="M15.59,16a.83.83,0,0,1-.64-.3.85.85,0,0,1,.09-1.2L18,12,15,9.46a.85.85,0,0,1,1.11-1.29l3.71,3.18a.87.87,0,0,1,.3.65.83.83,0,0,1-.3.64l-3.71,3.19A.85.85,0,0,1,15.59,16Z"
                      />
                      <path
                        class="cls-1"
                        d="M10.93,18.42h-.16a.87.87,0,0,1-.68-1L12.24,6.27a.86.86,0,0,1,1-.68.87.87,0,0,1,.68,1L11.76,17.73A.84.84,0,0,1,10.93,18.42Z"
                      /></svg
                  ></span>
                </div>
                <div class="p-1">
                  <span (click)="openAudioStoryModal(audioStory.assets.videoLandscapeStream, 'landscape-video')">
                    <svg data-name="Calque 1" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
                      <path
                        d="M7 12V6.78a1.34 1.34 0 012-1.15l8.52 5.12a1.46 1.46 0 010 2.5L9 18.37a1.34 1.34 0 01-2-1.15z"
                        fill="#fff"
                      ></path>
                    </svg>
                  </span>
                </div>
                <div class="p-1">
                  <span (click)="downloadSource(audioStory.assets.videoLandscapeAttachment, 'landscape-video')">
                    <svg id="Calque_1" data-name="Calque 1" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
                      <defs>
                        <style>
                          .cls-1 {
                            fill: #fff;
                          }
                        </style>
                      </defs>
                      <path
                        class="cls-1"
                        d="M11.41 17.08a.26.26 0 00.11.07.91.91 0 00.16.11.88.88 0 00.64 0 .91.91 0 00.16-.11.26.26 0 00.11-.07L16 13.81a.85.85 0 10-1.18-1.22l-1.94 1.88V5.35a.85.85 0 00-1.7 0v9.12l-1.97-1.88A.85.85 0 008 13.81z"
                      ></path>
                      <path
                        class="cls-1"
                        d="M18.5 16.57a.85.85 0 00-.85.85v1.64H6.35v-1.64a.85.85 0 00-1.7 0v2.49a.85.85 0 00.85.85h13a.85.85 0 00.85-.85v-2.49a.85.85 0 00-.85-.85z"
                      ></path></svg
                  ></span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </ng-container>

    <app-modal-audio-story></app-modal-audio-story>
  </div>
  <div *ngIf="currentPage !== lastPage && currentUrl" class="row d-flex flex-row mt-4">
    <div class="col-sm-12 d-flex justify-content-center align-items-center">
      <button (click)="loadMoreAudioStories()" class="btn btn-primary see-more-button">
        {{ 'SEE_MORE_CREATIONS' | translate }}
      </button>
    </div>
  </div>
</div>
